import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  skills: [],
  skill: {},
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  skillsListGet: (state) => state.skills,
  skillGet: (state) => state.skill,
  paginationGet: (state) => state.pagination,
};
const actions = {
  getSkills({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`skills?page=${page}`).then(
      (obj) => {
        var result = obj.data.skills;
        const pageresult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("skillsListSet", result);
        commit("setPagination", pageresult);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getSkillById({ commit }, payload) {
    service.getFun(`skills/${payload}`).then(
      (obj) => {
        var result = obj.data;
        commit("getSkillById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addSkill({ commit }, payload) {
    // debugger;
    service
      .postFun(service.deleteNullValues(payload), `skills/store`, null, {
        action: "getSkills",
      })
      .then(
        (result) => {
          result
            ? commit("addSkillStatus", result.success)
            : commit("addSkillStatus", false);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editSkill({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `skills/edit/${payload.id}`,
        null,
        { action: "getSkills" }
      )
      .then(
        (result) => {
          commit("editSkillStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteSkill({ commit }, payload) {
    service
      .postFun(null, `skills/delete/${payload.payload}`, null, {
        action: "getSkills",
      })
      .then(
        (result) => {
          commit("deleteSkillStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  skillsListSet(state, skills) {
    state.skills = skills;
  },
  addSkillStatus(state, Status) {
    state.addStatus = Status;
  },
  getSkillById(state, skill) {
    state.skill = skill;
  },
  editSkillStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteSkillStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
